import ModeratorListDisplay from "./ModerationListDisplay";
import LoadingDisplay from "../../../common/LoadingDisplay/LoadingDisplay";
import { useState, useCallback } from "react";
import PreloadModerationService from "../../../../services/PreloadService/PreloadModerationService";
import PreloadSettingsService from "../../../../services/PreloadService/PreloadSettingsService";
import { useTranslation } from "react-i18next";
import useAsync from "../../../../services/useAsync";

const ModeratorList = () => {
    const {
        loadBroadcasterModerators,
        broadcasterModerators,
        loadModerators,
        moderators,
        deleteModerator,
        addFirstModerator,
        updateModerator,
        replaceModerator,
    } = PreloadModerationService();

    const { t } = useTranslation("moderatorPage");

    const { loadUserSettings, updateUserSettings } = PreloadSettingsService();

    const [isLoading, setIsloading] = useState(false);

    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const [newModeratorInput, setNewModeratorInput] = useState("");
    const [inputDisplayMessage, setInputDisplayMessage] = useState("");

    const [manualApprovalState, setManualApprovalState] = useState(false);
    const loadPage = useCallback(async () => {
        setIsloading(true);

        const loadedPage = await Promise.all([
            loadBroadcasterModerators(),
            loadModerators(),
            loadUserSettings(),
        ]);

        // getsettings manaualapproval is not being updated fast enough
        setManualApprovalState(loadedPage[2].manualApproval);

        setIsloading(false);
    }, [loadBroadcasterModerators, loadModerators, loadUserSettings]);

    const removeModerator = async (moderator) => {
        replaceModerator({ ...moderator, isLoading: true });
        const response = await deleteModerator(moderator);
        if (!response) replaceModerator({ ...moderator, isLoading: false });
    };

    // add moderator
    const addModerator = async () => {
        if (!newModeratorInput) return;

        if (newModeratorInput.length > 25) {
            setInputDisplayMessage(t("moderatorNameTooLong"));
            setNewModeratorInput("");
            setTimeout(() => setInputDisplayMessage(""), 2000);

            return;
        }

        setIsButtonDisabled(true);
        setInputDisplayMessage(t("addingModerator"));

        await addFirstModerator(newModeratorInput);

        setInputDisplayMessage("");
        setNewModeratorInput("");
        setIsButtonDisabled(false);
    };

    const handelKeyPressAddingModerator = (event) => {
        if (event.key === "Enter") {
            addModerator();
        }
    };

    // manual approval toggle
    const approvalToggleLogic = async (state) => {
        if (isButtonDisabled) return;

        setIsButtonDisabled(true);
        setManualApprovalState(state);

        try {
            await updateUserSettings({ manualApproval: state });
        } catch (error) {
            // If api fails we reset to the saved value
            setManualApprovalState(!state);
        }

        setIsButtonDisabled(false);
    };

    useAsync(loadPage);

    return isLoading ? (
        <LoadingDisplay />
    ) : (
        <ModeratorListDisplay
            isButtonDisabled={isButtonDisabled}
            handelKeyPressAddingModerator={handelKeyPressAddingModerator}
            newModeratorInput={newModeratorInput}
            setNewModeratorInput={setNewModeratorInput}
            inputDisplayMessage={inputDisplayMessage}
            listOfAllModerators={moderators}
            listOfAllBroadcasters={broadcasterModerators}
            addModerator={addModerator}
            updateModerator={updateModerator}
            deleteModerator={removeModerator}
            manualApprovalState={manualApprovalState}
            approvalToggleLogic={approvalToggleLogic}
            replaceModerator={replaceModerator}
        />
    );
};

export default ModeratorList;
